import { Box, Typography } from "@mui/material";

import C from "@constants/constants";

import theme from "@theme/index";

export default function ProductUpdatesPopup() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        minWidth: "560px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 0.5,
        }}
      >
        <iframe
          allowFullScreen
          src={C.LOOM_DATA_RESOURCES_EMBED}
          style={{
            border: "none",
            height: "320px",
            width: "100%",
          }}
          title="Optimize Team Collaboration"
        />
        <Typography sx={{ mt: 3 }}>
          <strong>Here’s what’s new to streamline your marketing efforts:</strong>
        </Typography>
        <ul>
          <li>
            <strong>AI-Generated Marketing Summaries: </strong> Save time by leveraging AI craft marketing summaries for
            your technologies. Just provide key details and watch the magic happen.
          </li>
          <li>
            <strong>Customizable Summaries:</strong>Refine the tone, expand sections, or add key details with ease using
            prompts.
          </li>
          <li>
            <strong>Seamless Saving and Editing: </strong> Summaries are automatically saved to your technologies, with
            options to reset or start over anytime.
          </li>
        </ul>
      </Box>

      <Typography sx={{ fontWeight: "700", textAlign: "center" }}>
        Try it today in the Marketing Summary tab of your Technologies or contact support to set up a demo!
      </Typography>
      <Typography sx={{ color: theme.palette.primary.main, fontWeight: "700", textAlign: "center" }}>
        Have ideas or questions? Let us know in the Chat.
      </Typography>
    </Box>
  );
}
